import React from 'react';
import { Button } from 'components/ds';
import { Result } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.h1`
  color: var(--header-color-background);
  font-size: var(--font-giant);
  margin-bottom: var(--spacing-small);
`;

const SubTitle = styled.p`
  color: var(--header-color-background);
  font-size: var(--font-medium);
  margin-bottom: var(--spacing-regular);
  text-align: center;
`;

const Construction: React.FC = () => (
    <Container>
      <Result
        status="500"
        title={<Title>Página em Construção</Title>}
        subTitle={
          <SubTitle>
            Esta página está temporariamente indisponível pois está em desenvolvimento. 
            Por favor, tente novamente mais tarde.
          </SubTitle>
        }
        extra={[
          <Button 
            key="retry"
            type="highlight" 
            onClick={() => window.location.href = '/'}
            size="large"
            style={{ marginRight: '8px' }}
          >
            Atualizar Página
          </Button>
        ]}
      />
    </Container>
  );

export default Construction; 